export enum OrderProduct {
    PARCEL = "parcels",
    SUPER_BUNDLE="bundles",
    MINER = "miners",
    CARDS = "cards",
    AUTOSHIP = "subscriptions",

};